import { ChevronLeft, ChevronRight, CheckCircle2 } from 'lucide-react'
import { useEffect } from 'react'
import miwayLogo from '../../assets/miway.png'

export default function SurveyShell({
  step, total, title, intro, children,
  onBack, onNext, nextLabel = 'Weiter',
  nextVariant = 'secondary', validation,
  hideBack = false, hideNext = false,
  busy = false, logoSrc = miwayLogo, logoAlt = 'miway',
  logoNode = null,
}) {
  const pct = total ? Math.round((step / total) * 100) : 0
  // Wenn eine Validation-Meldung erscheint (Forced Choice), animiert ganz nach oben scrollen,
  // damit die Meldung auf jeden Fall sichtbar ist — auch wenn der User unten am Weiter-Button steht.
  useEffect(() => {
    if (!validation) return
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [validation])
  // Nochmal scrollen wenn der User erneut auf Weiter klickt obwohl die gleiche Meldung schon steht
  // (setValidation mit identischem String triggert keinen Re-Render → useEffect feuert nicht).
  const handleNext = () => {
    onNext?.()
    if (validation) {
      requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }))
    }
  }
  return (
    <div className="max-w-3xl mx-auto">
      <div className="card overflow-hidden">
        <div className="px-8 pt-8 pb-4">
          <div className="flex items-end justify-between gap-4">
            {logoNode ? logoNode : <img src={logoSrc} alt={logoAlt} className="h-12 w-auto" />}
            {step > 0 && total > 0 && (
              <div className="text-xs text-ink-mute">Schritt {step} von {total}</div>
            )}
          </div>
          <div className="mt-3 h-1 bg-teal-100/60 rounded-full overflow-hidden">
            <div className="h-full bg-teal transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
        </div>

        <div className="px-8 py-8">
          {title && <h1 className="text-2xl font-bold mb-2">{title}</h1>}
          {intro && <p className="text-ink-soft leading-relaxed mb-6">{intro}</p>}
          {validation && (
            <div className="mb-4 p-3 rounded-xl bg-rose-50 border border-rose-200 text-rose-800 text-sm">
              {validation}
            </div>
          )}
          <div>{children}</div>
        </div>

        <div className="px-8 py-5 bg-teal-50/40 border-t border-teal-100/60 flex items-center justify-between">
          <div>
            {!hideBack && (
              <button onClick={onBack} className="btn-ghost" disabled={busy}>
                <ChevronLeft size={18} /> Zurück
              </button>
            )}
          </div>
          <div className="flex items-center gap-3">
            {!hideNext && (
              <button
                onClick={handleNext}
                disabled={busy}
                className={nextVariant === 'primary' ? 'btn-primary' : 'btn-secondary'}
              >
                {nextLabel === 'Abschließen' ? <CheckCircle2 size={18} /> : null}
                {nextLabel}
                {nextLabel !== 'Abschließen' && <ChevronRight size={18} />}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
